import { Component, Input, OnInit } from "@angular/core";
import { GoldIds, GOLDS } from "@soposopo/sopo-models/dist/shop/Golds";
import { SwiperOptions } from "swiper";
import { ShopAnimationPartToPlay } from "../../services/purchase-animation/purchase-animation.service";


@Component({
    selector: 'shop-product-slider',
    templateUrl: './shop-product-slider.component.html',
    styleUrls: ['./shop-product-slider.component.scss'],
    standalone: false
})
export class ShopProductSliderComponent implements OnInit {
    @Input() playAnimation: ShopAnimationPartToPlay;
    swiperConfig: SwiperOptions = {
        slidesPerView: 4,
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    }
    goldArray: Array<[string, typeof GOLDS[GoldIds]]>;
    
    ngOnInit(): void {
        this.goldArray = Object.entries(GOLDS);
    }
    
}